<template>
    <v-container v-if="props.pagData?.pageInfo" class="pa-0">
        <v-row class='d-flex justify-end pb-6 filteritem'> 
            <v-col 
            class='me-auto ma-0 pa-0'>
            <ProductResultRasterNavigation 
            :tableOptions="tableOptions" :pagData="pagData"/>

            </v-col>  
            <v-col 
            class="py-0 px-1"
            cols="6"  sm="4" md="3" xl="2" v-if="mdAndUp">
                <v-select
                    density="compact"
                    variant="underlined"
                    :label="dataAll.getStatic('product_pag_items_per_page','sort')"
                    v-model="tableOptions.page_size"
                    :items="$PAG.itemPerPageOptions()"
                    :menu-props="selectOptionsWhiteBackground"
                >
                </v-select>
            </v-col> 


            <v-col cols="6"  sm="4" md="3" xl="2"
            class="py-0 px-1" v-if="mdAndUp"
            >
                <v-select
                density="compact"
                variant="underlined"
                :label="dataAll.getStatic('product_pag_sort','sort')"
                v-model="tableOptions.sort"
                :items="sortColumnData"
                item-title="title"
                item-value="value"
                :menu-props="selectOptionsWhiteBackground"
                ></v-select>
            </v-col>      
            <v-col cols="6"  sm="4" md="3" xl="2"
            class="py-0 px-1" v-if="mdAndUp"
             >

               <v-select
                density="compact"
                variant="underlined"
                :label="dataAll.getStatic('product_pag_sort_direction','direction')"
                v-model="tableOptions.direction"
                :items="[
                    { title: dataAll.getStatic('product_pag_sort_direction_asc','Ascending'), value: 'asc' },
                    { title: dataAll.getStatic('product_pag_sort_direction_desc','Descending'), value: 'desc' }
                ]"
                item-title="title"
                item-value="value"
                :menu-props="selectOptionsWhiteBackground"
                ></v-select>

            </v-col>                 
        </v-row>
      <v-row dense>
        <v-col
          v-for="(product, index) in tableData.products"
          :key="index"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
          xxl="2"
          @mouseover="!isMobile() && expandProduct(index)"
          @mouseleave="!isMobile() && collapseProduct(index)"
          style="position: relative;"
        >


          <v-card 
           class=" h-100 pa-1"
          
            style="position: relative; overflow: visible;"
            :style="{ zIndex: expandedProducts[index] ? 10 : 1 }"
          >
          <v-row
          class="pa-0 h-100"
          >
            <v-col cols="6" sm="5" md="12"
            class="pa-2"
            >
              <v-img 
              class="w-100"
                :alt="product.Images?.[0]?.ArticleImageAlt"
                :src="product.Images?.[0]?.ImageLink"
                aspect-ratio="1.5"
                @click="navigateTo(getProductLink(product))"
              ></v-img>
            </v-col>
            <v-col cols="6" sm="7" md="12"
            class="pa-5"
            >
              <div  >
                  <nuxt-link
                  class="text-decoration-none producttitel"
                  :to="getProductLink(product)">{{ product.Head.ArticleName }}</nuxt-link>
              </div>
              <div v-if="!expandedProducts[index]"  >
                {{ getFirstSelectorValue(product) }}
              </div>
             
              <v-btn 
                    v-if="isMobile()"
                    @click="toggleProduct(index)"
                    icon
                    size="small"
                    variant="text"
                  spaced="start"
                  style="float:right;"
                  > 
                    <v-icon>
                      {{ expandedProducts[index] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
              </v-btn>

            </v-col>
          </v-row>
           <div v-if="expandedProducts[index]" class="expandProduct pa-3 mt-1 mt-md-0
           "> 

              <v-card-text class="pa-0"  @click="navigateTo(getProductLink(product))">
              <v-row class="pa-0">
                  <v-col>

                    <!-- Extra info visible by mouseover -->
                    <div  >
                      <div
                      v-for="(selectorValue, indexSV) in product.SelectorValues" :key="indexSV">
                      <v-row class="py-2 px-3">        
                        <v-col cols="6" sm="auto" md="12" class="font-weight-bold pa-0 text-body-2 pr-3">  {{ indexSV }}</v-col>
                        <v-col 
                            cols="6" 
                            sm="auto" 
                            md="12" 
                            class="py-0 text-body-2 pa-0" 
                            v-html="`${selectorValue.value} ${headerUnitLookup[indexSV] || ''}`">
                        </v-col>
                      </v-row> 
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn 
                      v-if="getYesNo(siteSettings, 'Webshop')"
                      color="secondary" 
                      @click.stop="$PAG.addItemToCart(product.Head.ArticleNumber, product.Head.ArticleName, 1)"
                      style="position: absolute; top: 8px; right: 8px;"
                      icon
                    >
                      <SvgIconPublic 
                        v-if="siteSettings.IconWebshop && siteSettings.IconWebshop !==''" 
                        class="appbartext" 
                        :sizeIcon="iconSize" 
                        :url="siteSettings.IconWebshop"
                      />
                      <v-icon size="large" color="primary" v-else>mdi-cart</v-icon>
                    </v-btn>
                  </v-col>
              </v-row>
              </v-card-text>
           </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <ProductResultRasterNavigation v-if="pagData.totalCount / tableOptions.page_size >1" :tableOptions="tableOptions" :pagData="pagData"/>
      </v-row>

    </v-container>
</template>
<style scoped>
  .expandProduct{
      position: absolute;  
      left: 0; 
      right: 0; 
      background-color: white; 
      box-shadow: 0 4px 6px rgba(0,0,0,0.1); 
      
  }
</style>
<script setup>
import ProductResultRasterNavigation from "@/components/Products/PAG/ProductResultRasterNavigation.vue";
import SvgIconPublic from "@/components/Base/SvgIconPublic.vue";
import { mapSortedHeaders } from '~/utils/PAGhelper'
const dataAll = useDataAll()
const { mobile, xs,mdAndUp } = useDisplay();
const { $PAG } = useNuxtApp()
const siteSettings = useSiteSettingsStore();
// Reactive state for expanded products
const expandedProducts = reactive({});

const toggleProduct = (index) => {
  expandedProducts[index] = !expandedProducts[index];
};

function expandProduct(index) {
  expandedProducts[index] = true;
}
const selectedFilters = $PAG.selectFilterValueByUrl()

function collapseProduct(index) {
  expandedProducts[index] = false;
}
const props = defineProps({
    pagData: {
        type: Object,
        default: {},
    },

    pageItem: {
        type: Object,
        default: "",
    },
});

const DEFAULT_ITEMS_PER_PAGE = $PAG.defaultItemsPerPage()
let sortBy = ref([]);
const tableData = computed(() => props.pagData);
// Reactive options for page and sorting
const tableOptions = reactive({
    page: selectedFilters.page_nr??1,//props.pagData?.pageInfo?.page??1, // always start op page 1
    page_size: selectedFilters.page_size??DEFAULT_ITEMS_PER_PAGE,// props.pagData?.pageInfo?.size??DEFAULT_ITEMS_PER_PAGE, // Standard items per page
    sort: selectedFilters.sort,
    direction: selectedFilters.direction

});

watch(tableOptions, async (newValue) => {
    loadPAGWithOptions()
});


const getProductLink = (product) => {
  return $PAG.formatArticleUrl(product);
};


const headers = computed(() => {
  const headerArray = props.pageItem?.Selector?.[0]?.Header ?? [];
  return [...headerArray]
    .sort((a, b) => a.Number - b.Number) // Sort on number
    .map((headerObj, index) => ({
      title: headerObj.Name + (headerObj.Unit!=""?" ("+headerObj.Unit+")":""),
      key: headerObj.AttribuutSelectorName,
    }));
});

const sortColumnData = computed(() => mapSortedHeaders(props.pageItem?.Selector))

const headerUnitLookup = computed(() => {
  const headers = props.pageItem?.Selector?.[0]?.Header ?? [];
  return headers.reduce((acc, header) => {
    acc[header.AttribuutSelectorName] = header.Unit;
    return acc;
  }, {});
});

const getFirstSelectorValue = (product) => {
  const firstKey = Object.keys(product.SelectorValues)[0];
  return product.SelectorValues[firstKey]?.value || product.Head.ArticleNumber; // ArticleNumber is fallback
};

async function loadPAGWithOptions() {
    const newRoute = await $PAG.updateFilter($PAG.selectFilterValueByUrl(),
        {
            page_nr: tableOptions.page != 1 ? tableOptions.page : null,
            page_size: tableOptions.page_size != DEFAULT_ITEMS_PER_PAGE ? tableOptions.page_size : null,
            sort: tableOptions.sort ? tableOptions.sort : null,
            direction: tableOptions.direction ? tableOptions.direction : null

        }
    )
}

</script>
